export { default as botRoutes } from './bot';
export { default as botsRoutes } from './bots';
export { default as onboardingRoutes } from './onboarding';
export { default as settingsRoutes } from './settings';
export { default as billingRoutes } from './billing';
export { default as organisationRoutes } from './organisation';
